<template>
    <div class="m-3">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "ContentCard"
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
